export const lineCampaignTranslations = {
  // Header / gates
  back: "กลับไปหน้า LINE OA",
  connectTitle: "เชื่อมต่อ LINE Messaging ก่อน",
  connectDesc: "คุณต้องเชื่อมต่อ LINE Messaging API ก่อนจึงจะส่งแคมเปญได้",
  connectCta: "ไปที่การตั้งค่า LINE",
  title: "แคมเปญ",
  subtitle: "กรองลูกค้าจากสิ่งที่พวกเขาทำ แล้วส่งข้อความ LINE แบบเจาะจง",

  // Step 1 — audience
  step1: "เลือกกลุ่มเป้าหมาย",
  seg_awaiting_payment: "รอชำระเงิน",
  seg_awaiting_payment_desc: "สั่งซื้อแล้วแต่ยังไม่ได้ชำระ",
  seg_abandoned_cart: "ตะกร้าที่ถูกทิ้ง",
  seg_abandoned_cart_desc: "เพิ่มสินค้าลงตะกร้าแต่ไม่ได้ชำระ",
  seg_paid: "ลูกค้าที่ชำระแล้ว",
  seg_paid_desc: "ชำระเงินสำเร็จอย่างน้อย 1 ออเดอร์",
  seg_all_customers: "ลูกค้าทั้งหมด",
  seg_all_customers_desc: "ทุกคนที่เคยสั่งซื้อจากร้านของคุณ",
  minOrders: "จำนวนออเดอร์ขั้นต่ำ",
  minSpend: "ยอดใช้จ่ายรวมขั้นต่ำ (฿)",
  any: "ไม่จำกัด",
  refineLabel: "กรองเพิ่มตามประวัติการซื้อ",
  optional: "(ไม่บังคับ)",
  preview: "ดูรายชื่อผู้รับ",
  loading: "กำลังโหลด…",
  reachable: "พร้อมส่งทาง LINE",
  withoutLine: "ไม่มี LINE (ส่งไม่ได้)",

  // Step 2 — recipients
  step2: "เลือกผู้รับ",
  selectedCount: "เลือกแล้ว {a} จาก {b}",
  noMatch: "ยังไม่มีลูกค้าที่ส่ง LINE ได้ตรงกับกลุ่มนี้ในตอนนี้",
  colCustomer: "ลูกค้า",
  colOrders: "ออเดอร์",
  colSpend: "ยอดซื้อ",
  unpaidCount: "ค้างชำระ {n}",
  inCartLabel: "ในตะกร้า:",
  inOrderLabel: "ในออเดอร์:",
  inCartCount: "ในตะกร้า {n} ชิ้น:",
  inOrderCount: "ในออเดอร์ {n} ชิ้น:",
  itemsTotal: "{n} ชิ้น",
  moreItems: "+อีก {n}",
  newCustomer: "ลูกค้าใหม่ · ยังไม่เคยซื้อ",
  noOrdersHint: "—",

  // Step 3 — compose
  step3: "เขียนข้อความ",
  messagePlaceholder: "พิมพ์ข้อความที่ลูกค้าจะได้รับทาง LINE…",
  includeLinkTitle: "แนบลิงก์ชำระเงินของลูกค้าแต่ละคน",
  includeLinkDesc: "เราจะแนบลิงก์ออเดอร์ของลูกค้าแต่ละคน เพื่อให้ชำระได้ในแตะเดียว ลูกค้าที่ไม่มีออเดอร์ค้างชำระจะถูกข้าม",
  previewLabel: "ตัวอย่าง",
  messagePreviewPlaceholder: "ข้อความของคุณจะแสดงที่นี่…",
  sentTo: "ส่งให้ลูกค้า {n} คนแล้ว",
  skippedNote: "ข้าม {n} คน (ไม่มีออเดอร์ค้างชำระ) ",
  failedNote: "ล้มเหลว {n} คน",
  sendTo: "ส่งให้ลูกค้า {n} คน",
  sending: "กำลังส่ง…",
  // ผลลัพธ์เมื่อส่งไม่สำเร็จ (ไม่มีใครได้รับข้อความ)
  sendFailedTitle: "ส่งไม่สำเร็จ",
  sendFailedGeneric: "ไม่สามารถส่งข้อความได้",
  allSkippedNote: "ไม่ได้ส่งเลย — ลูกค้าทั้ง {n} คนไม่มีลิงก์ชำระเงิน (ไม่มีออเดอร์ค้างชำระ)",
  allFailedNote: "ไม่ได้ส่งเลย — ส่งไม่สำเร็จทั้ง {n} คน",
  lineRejected: "LINE ปฏิเสธการส่ง: {reason}",

  // Sent history (past targeted sends — Delivered + status only)
  historyTitle: "ประวัติการส่ง",
  historyEmpty: "ยังไม่มีประวัติการส่ง",
  historyColDate: "วันที่",
  historyColMessage: "ข้อความ",
  historyColDelivered: "ส่งถึง",
  historyColStatus: "สถานะ",
  historyPeople: "คน",
  historyStatusSent: "ส่งแล้ว",
  historyStatusFailed: "ไม่สำเร็จ",

  // Expandable recipient list (who received a send + blocked status)
  recipientsLoading: "กำลังโหลดรายชื่อผู้รับ…",
  recipientsError: "โหลดรายชื่อผู้รับไม่สำเร็จ",
  recipientsEmpty: "ไม่มีข้อมูลผู้รับสำหรับการส่งครั้งนี้",
  recipientsTitle: "ผู้รับ",
  recipientsBlocked: "บล็อกแล้ว",
  recipientsReached: "ส่งถึง",
  recipientsCappedNote: "ตรวจสอบสถานะบล็อกเฉพาะ {n} รายแรกจาก {total} ราย",

  // Visit attribution (มีผู้รับกี่คนที่เข้าชมร้านหลังการส่ง)
  visitsLoading: "กำลังโหลดยอดเข้าชม…",
  visitsLabel: "เข้าชม",
  visitsUniqueSuffix: "ราย",
  visitsOrders: "{n} ออเดอร์",
  visitsUnavailable: "ขณะนี้ยังไม่สามารถดูยอดเข้าชมได้",
  visitsNone: "ยังไม่มียอดเข้าชมที่ติดตามได้",
  visitsNote: "ติดตามได้เฉพาะการส่งที่มีลิงก์ และนับตั้งแต่มีฟีเจอร์นี้เป็นต้นไป",

  // Confirm dialog
  confirmTitle: "ยืนยันการส่งแคมเปญ?",
  confirmBody: "ระบบจะส่งข้อความนี้ให้ลูกค้า {n} คน ในกลุ่ม “{segment}”",
  eachGetsLink: " ลูกค้าแต่ละคนจะได้รับลิงก์ชำระเงินของตัวเอง",
  confirmUndo: " การส่งไม่สามารถยกเลิกได้",
  cancel: "ยกเลิก",
  sendNow: "ส่งเลย",

  // --- Audience filter builder ---
  customersWho: "ลูกค้าที่",
  connAnd: "และ",
  connOr: "หรือ",
  selectCollections: "เลือกคอลเลกชัน",
  selectProducts: "เลือกสินค้า",
  nSelected: "เลือกแล้ว {n}",
  search: "ค้นหา…",
  noMatches: "ไม่พบรายการ",
  addCondition: "เพิ่มเงื่อนไข",
  conditionsHelp: "เงื่อนไขทำงานจากบนลงล่างตาม และ / หรือ ของแต่ละแถว",
  removeCondition: "ลบเงื่อนไข",

  // condition types
  type_bought_collection: "ซื้อจากคอลเลกชัน",
  type_bought_product: "ซื้อสินค้า",
  type_not_bought_collection: "ไม่เคยซื้อจากคอลเลกชัน",
  type_not_bought_product: "ไม่เคยซื้อสินค้า",
  type_spend_on_collection: "ใช้จ่ายในคอลเลกชัน ≥",
  type_spend_on_product: "ใช้จ่ายกับสินค้า ≥",
  type_total_spend: "ยอดใช้จ่ายรวม ≥",
  type_qty_of_collection: "จำนวนชิ้นจากคอลเลกชัน ≥",
  type_qty_of_product: "จำนวนชิ้นของสินค้า ≥",
  type_order_count: "จำนวนออเดอร์รวม ≥",
  type_purchased_within: "ซื้อภายใน",
  type_not_purchased_within: "ไม่ได้ซื้อในช่วง",

  // condition groups
  group_purchased: "การซื้อ",
  group_didnt_buy: "ไม่ได้ซื้อ",
  group_spend: "ยอดใช้จ่าย",
  group_quantity: "จำนวน",
  group_recency: "ช่วงเวลา",

  // numeric suffixes
  suffix_baht: "฿",
  suffix_units: "ชิ้น",
  suffix_orders: "ออเดอร์",
  suffix_days: "วัน",

  // message type (text / rich / video)
  typeText: "ข้อความ",
  typeRich: "ริชเมสเสจ",
  typeVideo: "วิดีโอ",
  richHint: "รูปภาพที่เปิดลิงก์ของคุณ พร้อมหัวข้อและปุ่มกด",
  videoHint: "วิดีโอพร้อมรูปตัวอย่าง",

  // coupon picker (attribution)
  couponLabel: "คูปอง",
  couponOptional: "ไม่บังคับ",
  couponNone: "ไม่ใช้คูปอง",
  couponHint: "ผูกการส่งนี้กับคูปอง เพื่อดูยอดสั่งซื้อจริงที่มาจากแคมเปญนี้",
  couponInsert: "ใส่โค้ดในข้อความ",
  couponCodePrefix: "โค้ด: ",
}
